import { render, staticRenderFns } from "./rlmx.vue?vue&type=template&id=1d04c101&scoped=true&"
import script from "./rlmx.vue?vue&type=script&lang=js&"
export * from "./rlmx.vue?vue&type=script&lang=js&"
import style0 from "./rlmx.vue?vue&type=style&index=0&id=1d04c101&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d04c101",
  null
  
)

export default component.exports